import sanityClient from '@sanity/client';

export default sanityClient({
    projectId: "tlfh28z1",
    dataset: "production",
    useCdn: true
})